import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { UPDATE_SALESPERSON, SELECT_OPTIONS } from './queries';
import Autocomplete from '../Autocomplete';
import { salespersonRadioButtons } from 'app/src/elements/inputs';

const EditSalesperson = ({setShowModal, refetch, salesperson}) => {
  const [submitting, setSubmitting] = useState();
  const [vendorOrUser, setVendorOrUser] = useState('Vendor');
  const [selectOptions, setSelectOptions] = useState([]);
  const [updateSalesperson] = useMutation(UPDATE_SALESPERSON, {
    onCompleted: () => {
      if(refetch) {
        refetch();
      }
      setShowModal(false);
    }
  });

  const { loading: loading, error: error, data: data } = useQuery(SELECT_OPTIONS)

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    updateSalesperson({ variables: input });
  });

  const { control, handleSubmit, register, watch, setValue, formState: { errors } } = useForm({
    defaultValues: {
      id: salesperson?.id,
      vendorId: salesperson?.vendor?.id || '',
      userId: salesperson?.user?.id || '',
      commissionId: salesperson?.commission.id,
      sellerId: salesperson?.seller.id
    }
  });

  useEffect(() => {
    if(data) {
      setVendorOrUser(data?.vendor !== null ? 'Vendor' : 'User')
      setSelectOptions(data);
    }
  }, [data]);

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          {salespersonRadioButtons(vendorOrUser, setVendorOrUser, setValue)}
          {vendorOrUser === 'Vendor' ?
            <Input.Picker
              label='Vendor:'
              name='vendorId'
              control={control}
              errors={errors}
              options={selectOptions?.vendors?.map(vendor => {
                return { value: vendor.id, label: vendor.name }
              })}
              {...register("vendorId", {
                required: vendorOrUser === 'Vendor',
                validate: (val) => {
                  if (watch('vendorId') === 'Select') {
                    return "Required";
                  }
                },
              })}
            /> :
            <Input.Picker
              label='User:'
              name='userId'
              control={control}
              errors={errors}
              options={selectOptions?.users?.map(user => {
                return { value: user.id, label: `${user.firstName} ${user.lastName}` }
              })}
              {...register("userId", {
                required: vendorOrUser === 'User',
                validate: (val) => {
                  if (watch('userId') === 'Select') {
                    return "Required";
                  }
                },
              })}
            />
          }
          <Input.Picker
            label='Commission:'
            name='commissionId'
            control={control}
            errors={errors}
            options={selectOptions?.commissions?.map(commission => {
              return { value: commission.id, label: commission.name }
            })}
            {...register("commissionId", {
              required: "Required",
              validate: (val) => {
                if (watch('commissionId') === 'Select') {
                  return "Required";
                }
              },
            })}
          />
          <Input.Picker
            label='Seller:'
            name='sellerId'
            control={control}
            errors={errors}
            options={selectOptions?.sellers?.map(seller => {
              return { value: seller.id, label: seller.name }
            })}
            {...register("sellerId", {
              required: "Required",
              validate: (val) => {
                if (watch('sellerId') === 'Select') {
                  return "Required";
                }
              },
            })}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Salesperson" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditSalesperson;
